import { Add } from "@mui/icons-material";
import { ButtonBase } from "@mui/material";

interface Props {
  label: string;
  onClick: () => void;
  disabled: boolean;
  testId: string;
}

/** Botón punteado compacto para agregar otro elemento a una lista (ej. "Agregar otra garantía"). */
export const ButtonAddSlot = ({ label, onClick, disabled, testId }: Props) => (
  <ButtonBase
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
    sx={(theme) => ({
      gap: 1,
      px: "20px",
      py: "11px",
      borderRadius: "8px",
      border: "1px dashed",
      borderColor: "tokens.borderStrong",
      bgcolor: "background.paper",
      color: "primary.main",
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 600,
      transition: "border-color .2s ease, background-color .2s ease",
      "&:hover": { borderColor: "primary.main", bgcolor: "primary.base" },
      "&.Mui-disabled": { opacity: 0.5 },
      "& svg": { fontSize: 18 },
    })}
  >
    <Add />
    {label}
  </ButtonBase>
);
